import React, { useEffect, useState } from "react";
import style from "./SwitchAndSelect.module.css";
import {
  ClickAwayListener,
  FormControl,
  FormControlLabel,
  IconButton,
  InputLabel,
  MenuItem,
  Popper,
  Select,
  Switch,
} from "@mui/material";

import { FiInfo } from "react-icons/fi";
import {
  NavLink,
  useHistory,
} from "react-router-dom";

import { voivodeships as vvship } from "../../../../stuffs/Voivodeships";
import { icons } from "../../../../stuffs/Icons";

import styleItem from "../FilterBox/FilterItem/FilterItem.module.css";
import FilterItem from "../FilterBox/FilterItem/FilterItem";

import { useDispatch } from "react-redux";
import { setVoivodeshipValue } from "../../../../slices/voivodeship/voivodeshipSlice";
import { fetchCompaniesFiltered } from "../../../../slices/company/companySlice";

const SwitchAndSelect: React.FC = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  const [truck, setTruck] = useState("All");
  const [voivodeship, setVoivodeship] = useState("All");
  const [checked, setChecked] = useState({
    checkedIsInternational: false,
    checkedIsADR: false,
    checkedIsOversized: false,
  });


  const [activeTooltip, setActiveTooltip] = useState<string | null>(null);
  const [tooltipAnchor, setTooltipAnchor] = useState<HTMLElement | null>(null);

  const closeMobileTooltip = () => {
    setActiveTooltip(null);
    setTooltipAnchor(null);
  };

  const toggleMobileTooltip = (
    routing: string,
    element: HTMLElement
  ) => {
    if (activeTooltip === routing) {
      closeMobileTooltip();
    } else {
      setActiveTooltip(routing);
      setTooltipAnchor(element);
    }
  };


  /*
   * Na desktopie pokazujemy pierwsze 11 ikon.
   * Wszystkie kolejne trafiają pod menu "•••".
   */
  const visibleIcons = icons.slice(0, 10);
  const moreIcons = icons.slice(10);

  const voivodeshipExist = (name: string) => {
    return vvship.some((v) => v.value === name);
  };

  const getLastItem = (thePath: string) => {
    return thePath.substring(thePath.lastIndexOf("/") + 1);
  };

  // Wszystkie parametry requestu budujemy w jednym miejscu
  const buildArr = (
    v: string,
    t: string,
    intl: boolean,
    adr: boolean,
    ovd: boolean,
  ) => {
    return [v, t, intl, adr, ovd] as Array<string | boolean>;
  };

  const FetchOCompaniesAndSelect = (
    arr: Array<string | boolean>
  ) => {
    try {
      dispatch(fetchCompaniesFiltered(arr));
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    const path = history.location.pathname;
    const parts = path.split("/").filter(Boolean);

    // Strona główna
    if (path === "/") {
      setVoivodeship("All");
      setTruck("All");

      setChecked({
        checkedIsInternational: false,
        checkedIsADR: false,
        checkedIsOversized: false,
      });

      dispatch(setVoivodeshipValue("All"));

      FetchOCompaniesAndSelect(
        buildArr("All", "All", false, false, false)
      );

      return;
    }

    const first = parts[0];
    const second = parts[1];

    if (first && voivodeshipExist(first)) {
      setVoivodeship(first);
      dispatch(setVoivodeshipValue(first));

      if (second) {
        setTruck(second);
      }

      FetchOCompaniesAndSelect(
        buildArr(
          first,
          second || "All",
          checked.checkedIsInternational,
          checked.checkedIsADR,
          checked.checkedIsOversized
        )
      );
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [history.location.pathname]);

  // Zmiana województwa
  const handleChangeSelect = (event: any) => {
    const nextVoivodeship = event.target.value;

    setVoivodeship(nextVoivodeship);
    dispatch(setVoivodeshipValue(nextVoivodeship));

    /*
     * Nie robimy tutaj fetch.
     * Zmieniamy URL, a useEffect powyżej pobierze oferty.
     */
    history.push(`/${nextVoivodeship}/${truck}`);
  };

  /*
   * Switch nie zmienia URL, dlatego tutaj request
   * musi zostać wykonany bezpośrednio.
   */
  const handleChange = (event: any) => {
    const next = {
      ...checked,
      [event.target.name]: event.target.checked,
    };

    setChecked(next);

    const arr = buildArr(
      voivodeship,
      truck,
      next.checkedIsInternational,
      next.checkedIsADR,
      next.checkedIsOversized
    );

    FetchOCompaniesAndSelect(arr);
  };

  return (
    <div className={style.Content}>
      <div className={style.SwitchAndSelect}>
        <div className={style.Select}>
          <FormControl variant="standard" fullWidth>
            <InputLabel>Województwo</InputLabel>

            <Select
              value={voivodeship}
              onChange={handleChangeSelect}
              MenuProps={{
                anchorOrigin: {
                  vertical: "bottom",
                  horizontal: "left",
                },
                transformOrigin: {
                  vertical: "top",
                  horizontal: "left",
                },
                PaperProps: {
                  style: {
                    maxHeight: 320,
                  },
                },
              }}
            >
              {vvship.map((v) => (
                <MenuItem value={v.value} key={v.key}>
                  {v.title}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          {/* MOBILE – dropdown pojazdu */}
          {/* MOBILE – lista kategorii z opisami */}
<div className={style.MobileTruckSelect}>
  <FormControl variant="standard" fullWidth>
    <InputLabel>Kategoria</InputLabel>  
    <Select
      value={truck}
      onClose={closeMobileTooltip}
      MenuProps={{
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "left",
        },
        transformOrigin: {
          vertical: "top",
          horizontal: "left",
        },
        PaperProps: {
          style: {
            maxHeight: 320,
          },
        },
      }}
      renderValue={(value) => {
        const selectedIcon = icons.find(
          (icon) => icon.routing === value
        );

        return (
          <span className={style.MobileSelectedCategory}>
            <span className={style.MobileVehicleIcon}>
              {selectedIcon?.svg}
            </span>

            <span>{selectedIcon?.title}</span>
          </span>
        );
      }}
      onChange={(e) => {
        const value = e.target.value as string;

        closeMobileTooltip();
        setTruck(value);
        history.push(`/${voivodeship}/${value}`);
      }}
    >
      {icons.map((icon) => (
        <MenuItem
          key={icon.routing}
          value={icon.routing}
          className={style.MobileCategoryItem}
        >
          <span className={style.MobileVehicleIcon}>
            {icon.svg}
          </span>

          <span className={style.MobileCategoryTitle}>
            {icon.title}
          </span>

          {icon.tooltip && (
            <IconButton
              size="small"
              className={style.MobileInfoButton}
              aria-label={`Opis kategorii ${icon.title}`}
              aria-expanded={activeTooltip === icon.routing}
              onMouseDown={(e) => e.stopPropagation()}
              onTouchStart={(e) => e.stopPropagation()}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();

                toggleMobileTooltip(
                  icon.routing,
                  e.currentTarget
                );
              }}
            >
              <FiInfo size={20} />
            </IconButton>
          )}
        </MenuItem>
      ))}
    </Select>

  </FormControl>

  <Popper
    open={Boolean(activeTooltip && tooltipAnchor)}
    anchorEl={tooltipAnchor}
    placement="top"
    style={{ zIndex: 1500 }}
    modifiers={[
      {
        name: "offset",
        options: { offset: [0, 8] },
      },
      {
        name: "preventOverflow",
        options: { padding: 12 },
      },
    ]}
  >
    <ClickAwayListener onClickAway={closeMobileTooltip}>
      <div className={style.MobileTooltip} role="tooltip">
        {
          icons.find(
            (icon) => icon.routing === activeTooltip
          )?.tooltip
        }
      </div>
    </ClickAwayListener>
  </Popper>
</div>
        </div>
      </div>

      <div className={style.SwitchBox}>
        <FormControlLabel
          control={
            <Switch
              checked={checked.checkedIsInternational}
              onChange={handleChange}
              name="checkedIsInternational"
              color="primary"
            />
          }
          label="Transport międzynarodowy"
        />

        <FormControlLabel
          control={
            <Switch
              checked={checked.checkedIsADR}
              onChange={handleChange}
              name="checkedIsADR"
              color="primary"
            />
          }
          label="ADR (materiały niebezpieczne)"
        />
        <FormControlLabel
          control={
            <Switch
              checked={checked.checkedIsOversized}
              onChange={handleChange}
              name="checkedIsOversized"
              color="primary"
            />
          }
          label="Transport ponadnormatywny"
        />
      </div>

      {/* DESKTOP – ikonki */}
      <div className={style.VehicleIcons}>
        <div className={style.FilterBox}>
          {visibleIcons.map((icon, idx) => {
            const tooltipAlign =
              idx === 0 ? "left" : "center";

            return (
              <NavLink
                key={`${icon.title}-navlink`}
                to={`/${voivodeship}/${icon.routing}`}
                className={styleItem.NavLink}
                activeClassName={styleItem.Active}
                isActive={(_, location) =>
                  getLastItem(location.pathname) ===
                  icon.routing
                }
                onClick={() => {
                  /*
                   * Nie robimy fetch.
                   * NavLink zmieni URL,
                   * a useEffect wykona request.
                   */
                  setTruck(icon.routing);
                }}
              >
                <FilterItem
                  title={icon.title}
                  svg={icon.svg}
                  routing={icon.routing}
                  tooltip={icon.tooltip}
                  tooltipAlign={tooltipAlign}
                />
              </NavLink>
            );
          })}

          {/* POZOSTAŁE IKONY */}
          {moreIcons.length > 0 && (
            <div className={style.MoreWrapper}>
              <div className={style.MoreButton}>
                <span>•••</span>
              </div>

              <div className={style.MoreMenu}>
                {moreIcons.map((icon) => (
                  <NavLink
                    key={`${icon.title}-more`}
                    to={`/${voivodeship}/${icon.routing}`}
                    className={style.MoreItem}
                    activeClassName={style.MoreItemActive}
                    isActive={(_, location) =>
                      getLastItem(location.pathname) === icon.routing
                    }
                    onClick={() => {
                      setTruck(icon.routing);
                    }}
                  >
                    <div className={style.MoreIcon}>
                      {icon.svg}
                    </div>

                    <span className={style.MoreTitle}>
                      {icon.title}
                    </span>

                    {icon.tooltip && (
                      <span className={style.MoreTooltip} role="tooltip">
                        {icon.tooltip}
                      </span>
                    )}
                  </NavLink>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SwitchAndSelect;